import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { loginManager } from "@/services/security/login-manager";
import { userManager } from "@/services/security/user-manager";

class UserTimeoutManager {
  logoutTimer = null;
  async remind(isLogin = false) {
    if (isLogin || loginManager.getStayConnected()) {
      notificationManager.closeAlert();
      return;
    }
    this.startLogoutTimer();
    const reminder = await notificationManager.showAlert(
      "warning",
      i18n.global.t("expired_session"),
      i18n.global.t("stay_connected_question"),
      false,
      false,
      i18n.global.t("stay_connected_confirm"),
      null,
      "#000",
      "",
      false,
      false,
    );

    if (reminder.isConfirmed) {
      this.clearTimerLogout();
      localStorage.removeItem("studea-tokenExpirationDate");
      await loginManager.refreshConnection();
    }
  }

  logout(isLogin = false) {
    if (isLogin || loginManager.getStayConnected()) {
      notificationManager.closeAlert();
      return;
    }
    sessionStorage.setItem("studea-sessionExpired", 1);
    notificationManager.closeAlert();
    userManager.logout(true);
  }

  startLogoutTimer() {
    this.logoutTimer = setTimeout(this.logout, 1000 * 60 * 5);
  }

  clearTimerLogout() {
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
      this.logoutTimer = null;
    }
  }
}

export const userTimeoutManager = new UserTimeoutManager();
